// components/widgets/Stakeholders/StakeholderWidgetContainer.jsx
import React from "react";
import WidgetContainer from "../WidgetContainer.jsx";
import pandaImg from "../../../../../assets/panda_rootcause.png";
import RootCauseSelection from "./RootCauseSelection.jsx";
import RootCauseCelebration from "../../Celebration/RootCauseCelebration.jsx";
import MeetingPersonalitySequence from "./MeetingPersonalitySequence.jsx";

const RootcauseContainer = ({
  userId,
  subsectionId,
  onComplete,
  onPhaseChange,
}) => {
  return (
    <WidgetContainer
      userId={userId}
      subsectionId={subsectionId}
      onComplete={onComplete}
      onPhaseChange={onPhaseChange}
      intro={{
        image: pandaImg,
        title: "Underlying Root Cause",
        description:
          "Why do you behave in meetings the way you do? Answer a few questions and find out the root cause.",
        buttonLabel: "Get Started",
      }}
      steps={[
        {
          id: "builder",
          title: "Underlying Root Cause",
          description:
            "Choose the personality most suits you based on the behaviours you selected in the last exercise.",
          component: RootCauseSelection,
        },
        {
          component: RootCauseCelebration,
          fullScreen: true,
        },
        {
          component: MeetingPersonalitySequence,
          fullScreen: true,
        },
        
      ]}
    />
  );
};

export default RootcauseContainer;
